import React, {useEffect, useState} from 'react';
import {Button, Cascader, Flex, Menu, message, Table} from "antd";
import dayjs from "dayjs";
import {Outlet, useNavigate} from "react-router-dom";
import Cookies from "js-cookie";


const Knowledge_base=()=>{


    document.title='知识库';

    const [fetch_spu_info_data_source, setfetch_spu_info_data_source] = useState({
        "message": 2000,
        "value": "获取成功",
        "info": [
            {
                "id": "3",
                "uuid": "100003",
                "name": "Dell XPS 13",
                "description": "高性能轻薄笔记本电脑，适合商务办公和娱乐",
                "category_id": "2",
                "brand_id": "3",
                "sort_shop_uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                "status": "1",
                "status_type": "下架",
                "buy_it_now": "600",
                "image_card_img": "https://myupdat.leytcn.com/upload/1726199774_Untitled-3.jpg",
                "region_id": "6666",
                "created": "1",
                "node_value": null,
                "updated": "1732779731",
                "created_at": "2024-10-24 14:29:00",
                "updated_at": "2024-11-28 15:42:11",
                "country_code": "56888"
            },

        ]
    });

    let data_time=dayjs().unix();

    const navigate=useNavigate();

        useEffect(() => {

            window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部

            setfetch_spu_info_select_log({message:'dd',value:'',time:data_time})

            setfetch_sort_shop_select_log({message:'dd',value:'',time:data_time})
    }, []);

    const [fetch_spu_info_select_info, setfetch_spu_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_spu_info_select_log, setfetch_spu_info_select_log] = useState({message: '', value: '', time: 0})
    const fetch_spu_info = (e1: any) => {

        setfetch_spu_info_select_log({message: 'click', value: '', time: data_time})



        setfetch_spu_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


const [return_data_fetch_spu_info,setreturn_data_fetch_spu_info]=useState({});

    const fetch_spu_info_body = new FormData();


    fetch_spu_info_body.append('id', fetch_spu_info_select_info.value1);

    fetch_spu_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_spu_info_body.append('time', String(fetch_spu_info_select_info.time));

    fetch_spu_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/fetch/fetch_spu.php', {


                method: 'POST',
                body: fetch_spu_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

               setreturn_data_fetch_spu_info(return_data);



               setfetch_spu_info_data_source(return_data);
                //    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/knowledge_base')


                    break

                          case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/knowledge_base')


                    break


            }

        }


        if(fetch_spu_info_select_log.message!==''){

            data_async();
            setfetch_spu_info_select_log({message:'',value:'',time:0})
        }
    }, [fetch_spu_info_select_log]);


    const [fetch_sort_shop_select_info, setfetch_sort_shop_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_sort_shop_select_log, setfetch_sort_shop_select_log] = useState({message: '', value: '', time: 0})
    const fetch_sort_shop = (e1: any) => {

        setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})



        setfetch_sort_shop_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

    const [return_data_fetch_sort_shop,setreturn_data_fetch_sort_shop]=useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "2",
                "uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
                "userid": null,
                "sort_name": "健康保健",
                "created": null,
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": "6666",
                "row_num": "999",
                "children": []
            },
            {
                "id": "3",
                "uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                "userid": null,
                "sort_name": "桶装",
                "created": null,
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": "6666",
                "row_num": "999",
                "children": [
                    {
                        "id": "4",
                        "uuid": "3c67f228-d947-449a-a2e3-9cedf27da004",
                        "userid": null,
                        "sort_name": "12",
                        "created": "1729152105",
                        "status": "en",
                        "updated": null,
                        "parent_uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                        "country_code": "56888",
                        "region_parent_id": null,
                        "region_id": null,
                        "row_num": "999",
                        "children": []
                    }
                ]
            },
            {
                "id": "5",
                "uuid": "9a8dcd62-dc4c-415c-8b11-a3efd4494ebd",
                "userid": null,
                "sort_name": "11",
                "created": "1729152355",
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": null,
                "row_num": "999",
                "children": []
            }
        ]
    });

    const fetch_sort_shop_body = new FormData();


    fetch_sort_shop_body.append('id', fetch_sort_shop_select_info.value1);

    fetch_sort_shop_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_sort_shop_body.append('time', String(fetch_sort_shop_select_info.time));

    fetch_sort_shop_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/sort_shop/fetch/fetch_sort_shop.php', {


                method: 'POST',
                body: fetch_sort_shop_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_sort_shop(return_data);

                    //  setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/knowledge_base')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/knowledge_base')


                    break


            }

        }


        if(fetch_sort_shop_select_log.message!==''){

            data_async();
            setfetch_sort_shop_select_log({message:'',value:'',time:0})
        }
    }, [fetch_sort_shop_select_log]);



const onchange_cascader_d=(e1:any)=>{


    console.log({e1:e1})

    setfilter_spu_sort_uuid_select_log({message: 'click', value: '', time: data_time})



    setfilter_spu_sort_uuid_select_info({value1: e1, value2: '', value3: '', time: data_time})


}






    const [filter_spu_sort_uuid_select_info, setfilter_spu_sort_uuid_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [filter_spu_sort_uuid_select_log, setfilter_spu_sort_uuid_select_log] = useState({message: '', value: '', time: 0})
    const filter_spu_sort_uuid = (e1: any) => {

        setfilter_spu_sort_uuid_select_log({message: 'click', value: '', time: data_time})



        setfilter_spu_sort_uuid_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_filter_spu_sort_uuid,setreturn_data_filter_spu_sort_uuid]=useState({});

    const filter_spu_sort_uuid_body = new FormData();


    filter_spu_sort_uuid_body.append('cascader_uuid', JSON.stringify(filter_spu_sort_uuid_select_info.value1));

    filter_spu_sort_uuid_body.append('userToken', String(Cookies.get('userToken_chattool')));

    filter_spu_sort_uuid_body.append('time', String(filter_spu_sort_uuid_select_info.time));

    filter_spu_sort_uuid_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/filter/filter_spu.php', {


                method: 'POST',
                body: filter_spu_sort_uuid_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_filter_spu_sort_uuid(return_data);
                    setfetch_spu_info_data_source(return_data);
        //            setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/knowledge_base')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/knowledge_base')


                    break


            }

        }


        if(filter_spu_sort_uuid_select_log.message!==''){

            data_async();
            setfilter_spu_sort_uuid_select_log({message:'',value:'',time:0})
        }
    }, [filter_spu_sort_uuid_select_log]);




    const cancel_filter_spu=()=>{


        setfetch_spu_info_select_log({message:'1',value:'',time:data_time})

    }


    return(<div>

        <div style={{}}>

{/*

      <Menu style={{width:300,height:1000}} mode={'inline'} items={[{key: '1', label: '全部商品'}, {key: '2', label: '店铺分类',children:[{key: '11', label: '11'}]},]}>



            </Menu>
*/}


筛选分组：
            <Cascader  style={{width:'100%'}} onChange={onchange_cascader_d} options={return_data_fetch_sort_shop.info.map(item1=>({key:item1.uuid,label:item1.sort_name,value:item1.uuid,children:item1.children.map(item1_children=>({key:item1_children.uuid,label:item1_children.sort_name,value:item1_children.uuid}))}))}/>


            <p></p>

            <Button onClick={cancel_filter_spu} >取消筛选</Button>
            <p></p>
        <Table style={{width:'100%'}} dataSource={fetch_spu_info_data_source.info.map((item1:any)=>({key:item1.uuid,name:<div style={{display:'flex'}}>


                <div >

                    <div style={{flex: 0}}>
                        <img
                            style={{
                                width: '100px',  // 增大图片宽度
                                objectFit: 'cover',
                                height: '100px', // 增大图片高度
                                borderRadius: '4px',  // 可选：让图片有圆角
                            }}
                            src={item1.image_card_img}
                            alt={item1.specifications} // 添加alt属性用于无障碍访问
                        />
                    </div>

                </div>

                <div style={{marginLeft:15,content:'contents'}}>

                    {item1.name}
                    <p></p>
                    id：{item1.uuid}
                </div>

            </div>,value:item1.value,created:dayjs.unix(item1.created).format('YYYY-MM-DD HH:mm:ss'),select:''}))
        } columns={[{title:'商品名称',dataIndex:'name',key:'name'},{title:'创建时间',dataIndex:'created',key:'created'},{title:'操作',dataIndex:'name',key:'name',render:(text,record)=>(<div>

<Flex gap={'small'}>



     <label>商品信息</label>
        <a href={'/admin/detail?product_uuid='+record.key}>商品知识</a>
</Flex>

        </div>)}]}/>

 </div>

    </div>)

}


export default Knowledge_base;